import { useRef } from "react";
import threeIphones from "../../../assets/general/three-iphones.png";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

export function ProductHero() {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: "h2", duration: 0.9 });
  useScrollReveal(sectionRef, { targets: ".right img", delay: 0.2 });

  return (
    <section
      ref={sectionRef}
      id="section-eight"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding left-section-padding">
        <div className="eighth-section section-vertical-padding">
          <div className="left">
            <div className="section-masthead__heading">
              <h2 className="h2 mt-0 mb-0">
                PRODUCT
                <br />
                FEATURES
              </h2>
            </div>
          </div>
          <div className="right">
            <img src={threeIphones} alt="360PLUS product features" />
          </div>
        </div>
      </div>
    </section>
  );
}
